export default "__VITE_ASSET__Bg16PihU__"